<div class="panel">
    <div class="panel-header">
        <div class="panel-title"><h2>Starting a Deal Jacket</h2></div>
        <p>
            Depending on how a Deal Jacket is initiated, some of the information on this screen will already be populated. VIN is required, as are the buyer and
            Co-Buyer's first name, last name, email address and mobile phone number. You will also need to select how you want to add documents to the deal. The
            three methods are Express Upload, Custom Deal Type or Blank Deal. Once you have completed all the information, click the Start Deal Jacket button to
            proceed to the next step. Watch the video for a demonstration of this process using Custom Deal Type.
        </p>
    </div>

    <div class="panel-body">
        <p><b>Important notes about starting Deal Jackets:</b></p>
        <ul>
            <li>
                If you want to use Deal Jackets for documents that involve printing data from your DMS or other systems, you will need the enhanced service
                package. Contact us at {{ supportEmail }} or {{ tenantSupportPhone }} to learn more.
            </li>
            <li>
                Some Deal Jacket initiation methods require advance set up, like adding forms and documents to F&I Forms and creating Custom Deal Types. For
                more information on these set-up tasks, check out the help and guidance for those functions.
            </li>
            <li>
                Some information can be changed after a Deal Jacket is created, but other information cannot. If any of the information that cannot be changed
                needs to be added or updated, you will have to delete an existing Deal Jacket and create a new one.
            </li>
            <li><b>Changes you can make:</b> updating buyer/Co-Buyer details, switching the buyer and Co-Buyer, changing the vehicle</li>
            <li>
                <b>Changes you cannot make:</b> changing the name of the person who created the jacket, adding a deal number, adding a trade-in vehicle or
                updating trade-in vehicle details
            </li>
        </ul>
    </div>
</div>
